import { Box } from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { PricingButton } from "./CoverPageHeader"
import { useCoverPageContext } from "./CoverPageProvider"

/** Show the mobile CTA only while the header is away and Offers are offscreen. */
export function useCoverPagePricingToolbarVisible() {
  const headerCollapsed = useCoverPageContext((v) => v.headerCollapsed)
  const offersSectionRef = useCoverPageContext((v) => v.offersSectionRef)
  const scrollContainerRef = useCoverPageContext((v) => v.scrollContainerRef)
  const offers = useCoverPageContext((v) => v.offers)
  const resourceId = useCoverPageContext((v) => v.resourceId)
  const [offersInView, setOffersInView] = useState(false)

  // Offers may mount after the toolbar or be replaced when changing resources.
  useEffect(() => {
    setOffersInView(false)
    const section = offersSectionRef.current
    if (!section) return
    const observer = new IntersectionObserver(
      ([entry]) => setOffersInView(entry.isIntersecting),
      { root: scrollContainerRef.current }
    )
    observer.observe(section)
    return () => observer.disconnect()
  }, [offers, resourceId, offersSectionRef, scrollContainerRef])

  return headerCollapsed && !offersInView && Boolean(offers?.length)
}

export default function CoverPagePricingToolbarOption() {
  return (
    <Box
      position="relative"
      css={{
        "& .chakra-button:not(.chakra-link)": {
          height: "auto",
          maxHeight: "40px"
        }
      }}
    >
      <motion.div
        key="pricing"
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: "auto", opacity: 1 }}
        exit={{ width: 0, opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{ overflow: "hidden" }}
      >
        <PricingButton
          collapsed
          rightIcon={<Pathicon icon="chevron-right" size="1.2em" />}
          px={4}
          py={2}
        />
      </motion.div>
    </Box>
  )
}
